export default "__VITE_ASSET__c59cfacb__"